// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/img/veeplogo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}


.greenButton {
  background-color: #1DB954 !important;
  color: #ffffff !important;
  border-color: #036735 !important;
  border-radius: 50rem !important;
  padding: 0.375rem 0.75rem;
  display: inline-block;
  font-weight: bold !important;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid transparent;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.greenButton:hover {
  background-color: #16a03f !important;
  /* Un tono más oscuro de verde */
  border-color: #025228 !important;
  /* Borde ligeramente más oscuro */
  transform: scale(1.05);
  /* Opcional: ligero efecto de zoom */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  /* Opcional: sombra sutil */
}

.greenColour {
  font-weight: bold !important;
  color: #036735 !important;
}

.logo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}


.home-page {
  background: linear-gradient(to top, #d4edda, #ffffff);
  /* Verde pastel a blanco */
  background-attachment: fixed;
  /* Fijo al fondo para un efecto profesional */
}


/* Estilo para la tarjeta de login */
.login-card {
  border-radius: 15px;
  background: #ffffff;
  padding: 20px;
}

/* Ajusta el ancho del formulario para dispositivos pequeños */
@media (max-width: 576px) {
  .login-card {
    padding: 15px;
  }

  .btn-green {
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;EACjB,6BAA6B;EAC7B,iIAAiI;AACnI;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,gCAAgC;EAChC,iCAAiC;EACjC,sBAAsB;EACtB,oCAAoC;EACpC,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,yDAAkD;EAClD,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,qDAAqD;EACrD,0BAA0B;EAC1B,4BAA4B;EAC5B,6CAA6C;AAC/C;;;AAGA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA,8DAA8D;AAC9D;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n.greenButton {\n  background-color: #1DB954 !important;\n  color: #ffffff !important;\n  border-color: #036735 !important;\n  border-radius: 50rem !important;\n  padding: 0.375rem 0.75rem;\n  display: inline-block;\n  font-weight: bold !important;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  border: 1px solid transparent;\n  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n}\n\n.greenButton:hover {\n  background-color: #16a03f !important;\n  /* Un tono más oscuro de verde */\n  border-color: #025228 !important;\n  /* Borde ligeramente más oscuro */\n  transform: scale(1.05);\n  /* Opcional: ligero efecto de zoom */\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  /* Opcional: sombra sutil */\n}\n\n.greenColour {\n  font-weight: bold !important;\n  color: #036735 !important;\n}\n\n.logo {\n  background-image: url('./assets/img/veeplogo.png');\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  width: 100%;\n  height: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n.home-page {\n  background: linear-gradient(to top, #d4edda, #ffffff);\n  /* Verde pastel a blanco */\n  background-attachment: fixed;\n  /* Fijo al fondo para un efecto profesional */\n}\n\n\n/* Estilo para la tarjeta de login */\n.login-card {\n  border-radius: 15px;\n  background: #ffffff;\n  padding: 20px;\n}\n\n/* Ajusta el ancho del formulario para dispositivos pequeños */\n@media (max-width: 576px) {\n  .login-card {\n    padding: 15px;\n  }\n\n  .btn-green {\n    font-size: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
